import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";
import { ISaveStateTaxParamsRequest } from "./saveStateTaxParams.jsonschema";

export const saveStateTaxParams = (axios: IAxiosInstance) => {
  return async (request: ISaveStateTaxParamsRequest) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ISaveStateTaxParamsResponse"]
    >(`/saveStateTaxParams`, request);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
